
const TWO_FINGER_SUPPORT = false;

const ALPHAS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZÅÄÖ'.split('');
const LETTER_GROUPS = ['#'].concat(ALPHAS);

const SERVICE_TYPES = [
  { id: 5, name: 'service.parking', icon: 'ic_parking', pinicon: 'pin_parking' },
  { id: 6, name: 'service.toilet', icon: 'ic_toilet', pinicon: 'pin_toilet' },
  { id: 7, name: 'service.elevator', icon: 'ic_elevator', pinicon: 'pin_elevator' },
  { id: 8, name: 'service.atm', icon: 'ic_atm', pinicon: 'pin_atm' },
  { id: 9, name: 'service.escalator', icon: 'ic_escalator', pinicon: 'pin_escalator' },
  { id: 10, name: 'service.stairs', icon: 'ic_stairs', pinicon: 'pin_stairs' },
  { id: 11, name: 'service.taxi', icon: 'ic_taxi', pinicon: 'pin_taxi' },
  { id: 12, name: 'service.recycling', icon: 'ic_recycling', pinicon: 'pin_recycling' },
  { id: 13, name: 'service.train', icon: 'ic_train', pinicon: 'pin_train' },
  { id: 14, name: 'service.metro', icon: 'ic_metro', pinicon: 'pin_metro' },
  { id: 15, name: 'service.tram', icon: 'ic_tram', pinicon: 'pin_tram' },
  { id: 16, name: 'service.bus', icon: 'ic_bus', pinicon: 'pin_bus' },
  { id: 17, name: 'service.stop', icon: 'ic_stop', pinicon: 'pin_stop' },
  { id: 18, name: 'service.nurseryRoom', icon: 'ic_nursery-room' , pinicon: 'pin_nursery-room' },
  { id: 19, name: 'service.notInUse', icon: 'ic_not-in- use', pinicon: 'pin_not-in-use' },
  { id: 20, name: 'service.infoDesk', icon: 'ic_info-desk' , pinicon: 'pin_info-desk' },
  { id: 21, name: 'service.directory', icon: 'ic_directory', pinicon: 'pin_direcotry' },
  { id: 22, name: 'service.toiletAccessible', icon: 'ic_toilet-accessible' , pinicon: 'pin_accessible-toilet' },
  { id: 23, name: 'service.bottleRecycling', icon: 'ic_bottle-recycling' , pinicon: 'pin_bottle-recycling' },
  { id: 24, name: 'service.playground', icon: 'ic_playground', pinicon: 'pin_playground' },
  /* Need custom icon */
  { id: 100, name: 'service.lockers', icon: 'ic_lockers', pinicon: 'pin_lockers' },
  { id: 101, name: 'service.park', icon: 'ic_park', pinicon: 'pin_park' },
  { id: 102, name: 'service.parcelPickup', icon: 'ic_parcel-pickup', pinicon: 'pin_parcel-pickup' },
  { id: 103, name: 'service.parkingMeter', icon: 'ic_parking-meter', pinicon: 'pin_parking-meter' },
  { id: 104, name: 'service.evCharging', icon: 'ic_ev-charging', pinicon: 'pin_ev-charging' }
].map(x => (x.className = x.pinicon, x));

const INTERPOLATION_STEP = 7;
const MAX_VALUE = Number.POSITIVE_INFINITY;
const ESCALATOR_COST = 10000;    // Cost of changing the floor with escalators
const ELEVATOR_COST = 9200; // Cost of changing the floor with elevator
const ESCALATOR_SERVICE_PENALTY = 100;// Cost of stepping into escalator
const ELEVATOR_SERVICE_PENALTY = 2100;// Cost of stepping into elevator
const NODE_SELECT_ELLIPSE_RADIUS = 15;
const ICON_SIZE = 48;

/*STOREMENU IN MAP VIEW*/
const STOREMENU = { width: 300, height: 190, oneItemheight: 114, linewidth: 30, margin: 10 };

module.exports = {
  TWO_FINGER_SUPPORT,
  ALPHAS,
  LETTER_GROUPS,
  SERVICE_TYPES,
  INTERPOLATION_STEP,
  MAX_VALUE,
  ESCALATOR_COST,
  ELEVATOR_COST,
  ESCALATOR_SERVICE_PENALTY,
  ELEVATOR_SERVICE_PENALTY,
  ICON_SIZE,
  NODE_SELECT_ELLIPSE_RADIUS,
  STOREMENU
};
